import { render, staticRenderFns } from "./cabinetStatus.vue?vue&type=template&id=66d2f126&"
import script from "./cabinetStatus.vue?vue&type=script&lang=js&"
export * from "./cabinetStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports